import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
// import BreadCrumb from '../../../Components/Common/BreadCrumb';
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import List from "list.js";
//Import Flatepicker
import Flatpickr from "react-flatpickr";

// Import Images
import avatar1 from "../../../src/assets/images/users/avatar-1.jpg";
import avatar2 from "../../../src/assets/images/users/avatar-2.jpg";
import avatar3 from "../../../src/assets/images/users/avatar-3.jpg";
import avatar4 from "../../../src/assets/images/users/avatar-4.jpg";
import avatar5 from "../../../src/assets/images/users/avatar-5.jpg";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const StockTransactions = () => {
  const [modal_list, setmodal_list] = useState(false);
  const tog_list = () => {
    setmodal_list(!modal_list);
  };

  const [modal_delete, setmodal_delete] = useState(false);
  const tog_delete = () => {
    setmodal_delete(!modal_delete);
  };

  useEffect(() => {
    const attroptions = {
      valueNames: [
        "name",
        "born",
        {
          data: ["id"],
        },
        {
          attr: "src",
          name: "image",
        },
        {
          attr: "href",
          name: "link",
        },
        {
          attr: "data-timestamp",
          name: "timestamp",
        },
      ],
    };

    // pagination list

    new List("pagination-list", {
      valueNames: ["pagi-list"],
      page: 3,
      pagination: true,
    });
  });

  document.title = "Stock Transactions ";

  const mockData = [
    {
      stock_transactions_id: "104",
      item_id: "102",
      store_id: "1001",
      site_id: "1020",
      transaction_date: "20-5-2022",
      transaction_type: "Purchase",
      operation_type: "Stock",
      quantity: "100",
      reference_number: "1001",
      action_date: "10-09-2022",
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Stock Transactions "
            pageTitle="Stock Transactions"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add Stock Transactions, Edit & Remove
                  </h4>
                </CardHeader>

                <CardBody>
                  <div id="Purchasestable">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div>
                          <Button
                            color="success"
                            className="add-btn me-1"
                            onClick={() => tog_list()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add
                          </Button>
                          <Button
                            className="btn btn-soft-danger"
                            // onClick="deleteMultiple()"
                          >
                            <i className="ri-delete-bin-2-line"></i>
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="cardTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th scope="col" style={{ width: "50px" }}>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="checkAll"
                                  value="option"
                                />
                              </div>
                            </th>
                            <th
                              className="sort"
                              data-sort="stock_transactions_id"
                            >
                              Stock Transactions ID
                            </th>
                            <th className="sort" data-sort="item_id">
                              Item ID
                            </th>
                            <th className="sort" data-sort="store_id">
                              Store ID
                            </th>
                            <th className="sort" data-sort="site_id">
                              Site ID
                            </th>
                            <th className="sort" data-sort="transaction_date">
                              Transaction Date
                            </th>
                            <th className="sort" data-sort="transaction_type ">
                              Transaction Type
                            </th>
                            <th className="sort" data-sort="operation_type ">
                              Operation Type
                            </th>
                            <th className="sort" data-sort="quantity">
                              Quantity
                            </th>
                            <th className="sort" data-sort="reference_number">
                              Reference Number
                            </th>
                            <th className="sort" data-sort="action_date">
                              Action Date
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {mockData.map((data, index) => {
                            return (
                              <tr key={index}>
                                <th scope="row">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name="checkAll"
                                      value="option4"
                                    />
                                  </div>
                                </th>
                                <td className="id" style={{ display: "none" }}>
                                  <Link
                                    to="#"
                                    className="fw-medium link-primary"
                                  >
                                    #VZ2104
                                  </Link>
                                </td>
                                <td className="StockTransactions_id">
                                  {data.stock_transactions_id}
                                </td>
                                <td className="item_id"> {data.item_id} </td>
                                <td className="store_id">{data.store_id}</td>
                                <td className="site_id">{data.site_id}</td>
                                <td className="transaction_date">
                                  {" "}
                                  {data.transaction_date}{" "}
                                </td>
                                <td className="transaction_type">
                                  {data.transaction_type}
                                </td>
                                <td className="operation_type">
                                  {" "}
                                  {data.operation_type}{" "}
                                </td>

                                <td className="quantity"> {data.quantity} </td>
                                <td className="reference_number">
                                  {" "}
                                  {data.reference_number}{" "}
                                </td>
                                <td className="action_date">
                                  {" "}
                                  {data.action_date}{" "}
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-sm btn-success edit-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#showModal"
                                      >
                                        Edit
                                      </button>
                                    </div>
                                    <div className="remove">
                                      <button
                                        className="btn btn-sm btn-danger remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className="page-item pagination-prev disabled"
                          to="#"
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0"></ul>
                        <Link className="page-item pagination-next" to="#">
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* end of container */}
        </Container>
      </div>

      {/* Add Modal */}
      {/* StockTransactions From */}

      <Modal
        isOpen={modal_list}
        toggle={() => {
          tog_list();
        }}
        centered
        size="lg"
      >
        <ModalHeader className="bg-light p-3">
          Add New Stock Transactions
          <Button
            type="button"
            onClick={() => {
              setmodal_list(false);
            }}
            className="btn-close"
            aria-label="Close"
          ></Button>
        </ModalHeader>
        <form>
          <ModalBody>
            <div className="mb-3" id="modal-id" style={{ display: "none" }}>
              <label htmlFor="id-field" className="form-label">
                ID
              </label>
              <input
                type="text"
                id="id-field"
                className="form-control"
                placeholder="ID"
                readOnly
              />
            </div>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Stock Transactions ID</label>
                  <input
                    type="number"
                    id="StockTransactions_id-field"
                    className="form-control"
                    placeholder="Enter Stock Transactions ID"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Item ID</label>
                  <input
                    type="number"
                    id="item_id-field"
                    className="form-control"
                    placeholder="Enter Item ID"
                    required
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Store ID</label>
                  <input
                    type="number"
                    id="store_id-field"
                    className="form-control"
                    placeholder="Enter Store ID"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Site ID</label>
                  <input
                    type="number"
                    id="site_id-field"
                    className="form-control"
                    placeholder="Enter Site ID"
                    required
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Transaction Date</label>
                  <input
                    type="date"
                    id="transaction_date-field"
                    className="form-control"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label>Transaction Type </label>
                  <select
                    className="form-select "
                    id="transaction_type"
                    required
                  >
                    <option selected>Choose...</option>
                    <option value="Opening Balance">Opening Balance</option>
                    <option value="Purchase">Purchase</option>
                    <option value="Purchase Return">Purchase Return</option>
                    <option value="Sale">Sale</option>
                    <option value="Sale Return">Sale Return</option>
                  </select>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label> Operation Type </label>
                  <select
                    className="form-select "
                    id="transaction_type"
                    required
                  >
                    <option selected>Choose...</option>
                    <option value="Inventory">Inventory</option>
                    <option value="Purchase">Purchase</option>
                    <option value="Stock">Stock</option>
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label"> Quantity</label>
                  <input
                    type="number"
                    id="quantity-field"
                    className="form-control"
                    placeholder="Enter Quantity"
                    required
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label"> Reference Number</label>
                  <input
                    type="number"
                    id="reference_number-field"
                    className="form-control"
                    placeholder="Enter Reference Number"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label"> Action Date</label>
                  <input
                    type="date"
                    id="action_date-field"
                    className="form-control"
                    placeholder="Enter Action Date"
                    required
                  />
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                Add Stock Transactions
              </button>
              <button type="button" className="btn btn-success" id="edit-btn">
                Update
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>

      {/* Remove Modal */}
      <Modal
        isOpen={modal_delete}
        toggle={() => {
          tog_delete();
        }}
        className="modal fade zoomIn"
        id="deleteRecordModal"
        centered
      >
        <div className="modal-header">
          <Button
            type="button"
            onClick={() => setmodal_delete(false)}
            className="btn-close"
            aria-label="Close"
          >
            {" "}
          </Button>
        </div>
        <ModalBody>
          <div className="mt-2 text-center">
            <lord-icon
              src="https://cdn.lordicon.com/gsqxdxog.json"
              trigger="loop"
              colors="primary:#f7b84b,secondary:#f06548"
              style={{ width: "100px", height: "100px" }}
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>Are you Sure ?</h4>
              <p className="text-muted mx-4 mb-0">
                Are you Sure You want to Remove this Record ?
              </p>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn w-sm btn-light"
              onClick={() => setmodal_delete(false)}
            >
              Close
            </button>
            <button
              type="button"
              className="btn w-sm btn-danger "
              id="delete-record"
            >
              Yes, Delete It!
            </button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default StockTransactions;
